import React, { Component } from 'react'
import { withRouter, Link } from 'react-router';
import { Container, Grid, Row, Col } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { InfoBox, Uppercase } from '../components/OnePager/OnePageStyle'

import { NavSpacer, LogeButtonSlim } from '../components/GeneralStyle'

import UpdatePartnerContactModal from '../components/partner/modals/UpdatePartnerContactModal'
import UpdatePartnerInformationModal from '../components/partner/modals/UpdatePartnerInformationModal'
import UpdatePartnerHeaderImageModal from '../components/partner/modals/UpdatePartnerHeaderImageModal'
import UpdatePartnerLogoModal from '../components/partner/modals/UpdatePartnerLogoModal'

import editIcon from '../images/icons/partners/edit.svg'
import editImageIcon from '../images/icons/partners/image.svg'
import breadCrumbArrow from '../images/breadcrumb_arrow.png'

import './PartnerDetail.css'
import styled from 'styled-components'
import config from 'react-global-configuration';


@inject('partnerInformationStore', 'userStore')
@observer
class PartnerDetail extends Component {

  constructor(props) {
    super(props)

    this.state = {
      industry: null
    }
  }

  componentDidMount() {
    this.props.partnerInformationStore.loadPartnerFromShortname(this.props.match.params.shortname)
    this.setState({ industry: this.props.partnerInformationStore.getLastIndustry() })
    this.props.partnerInformationStore.setLastIndustry(null)
  }

  render() {

    const { currentPartner: partner, partnerInformationMissing, partnerContactInformationMissing } = this.props.partnerInformationStore

    const isOwnCompany = partner && this.props.userStore.company && partner.objectId === this.props.userStore.company.objectId

    return (
      <Grid fluid>
        <div className="pageWrapper detail_page" style={{marginTop: '60px', background: '#f5f5f5'}}>
          <NavSpacer />
          <HeroContainer>
            <InfoBox className="info-box-top content-wrapper" style={{width: '100%', marginTop: 0}}>
              <div className="breadcrumbs">
                <img src={breadCrumbArrow}  onClick={() => {this.props.history.goBack()}} />
                <div className="path">
                  <span onClick={() => {this.props.history.push("/partners/")}}>Branchen</span> / {this.state.industry ? (<span onClick={() => {this.props.history.goBack()}}>{this.state.industry}</span>) : ''}{this.state.industry ? ' / ' : ''}<span style={{textDecoration: 'underline'}}>{partner ? partner.name : ''}</span>
                </div>
              </div>
            </InfoBox>
          </HeroContainer>
          { partner && <main>
            <InfoBox className="info-box content-wrapper" style={{paddingTop: 0}}>
              <div className="partner-image" style={{position: 'relative'}} >
                { partner.headerImage && partner.headerImage !== 'company_default_image_' && <img src={`${config.get('CLOUDINARY_URL')}q_auto/w_2000/${ partner.headerImage }.jpg`} style={{objectFit: 'cover', width: '100%', height: '100%'}}/> }
                { isOwnCompany && <EditInformationButton style={{margin: '20px 20px 0 0'}} onClick={() => this.updatePartnerHeaderImageModal.openModal() }><img src={editImageIcon} /></EditInformationButton> }
              </div>

              <MediaQuery query="(min-device-width: 901px)">
                <div className="partner-info-container">
                  <div className="partner-sidebar">
                    <div style={{position: 'relative'}} className="partner-logo">
                      { partner.logo && <img src={`${config.get('CLOUDINARY_URL')}q_auto/w_500/${ partner.logo }.jpg`} /> }
                      { isOwnCompany && <EditInformationButton onClick={() => this.updatePartnerLogoModal.openModal() }><img src={editImageIcon} /></EditInformationButton> }
                    </div>
                    <LogeButtonSlim
                        style={{ borderRadius: 0, width: 200, marginBottom: '32px' }}
                        hoverFontColor={"white"}
                        onClick={() => { window.open('https://' + partner.website, '_blank') }}>
                        Zur Website &gt;</LogeButtonSlim>
                    <div className="info-group">
                      <span className="group-title">Standort</span>
                      <p>
                        { partner.street }<br />
                        { partner.postcode } { partner.location }
                        {/*<br /> Österreich*/}
                      </p>
                    </div>
                    <div className="info-group">
                      <span className="group-title">Kontakt</span>
                      <p>
                        <a href={'tel:' + partner.phone}>Tel.: { partner.phone }</a><br />
                        <a href={'mailto:' + partner.email}>E-Mail: { partner.email }</a>
                      </p>
                    </div>
                    { partner.contact && <div className="info-group">
                      <span className="group-title">Information</span>
                      <p>
                        { partner.contact.position }:<br />
                        { partner.contact.firstname } { partner.contact.lastname }
                        <br /><br />
                        UID-Nummer: <br />
                        { partner.uidNumber }
                      </p>
                    </div>
                    }
                  </div>
                  <div className="partner-main">
                    <div style={{width: '100%'}}>
                      <div className="group-title" style={{position: 'relative'}}>
                        Firma
                        { isOwnCompany && <EditInformationButton highlighted={ partnerInformationMissing } onClick={() => this.updateInformationModal.openModal() } ><img src={editIcon} /></EditInformationButton> }
                      </div>
                      <h1 className="company-name">{ partner.name }</h1>
                      <div className="info-group">
                        <span className="group-title">Beschreibung</span>
                        <p style={{whiteSpace: 'pre-line'}}>
                          { partner.description || "-" }
                        </p>
                      </div>
                      <div className="info-group">
                        <span className="group-title">The-Loge Angebote</span>
                        <p style={{whiteSpace: 'pre-line'}}>
                          { partner.deals || "-" }
                        </p>
                      </div>
                    </div>
                    <div className="contact-info">
                      <div>
                        <span className="group-title" style={{display: 'block', position: 'relative'}}>
                          Kontaktperson
                          { isOwnCompany && <EditInformationButton  highlighted={ partnerContactInformationMissing } onClick={() => this.updateContactModal.openModal() }><img src={editIcon} /></EditInformationButton> }
                        </span>
                        <div style={{display: 'flex', marginBottom: '32px', alignItems: 'center'}}>
                          { partner.contact && partner.contact.profileImage && <img src={`${config.get('CLOUDINARY_URL')}q_auto/w_500/${partner.contact.profileImage }.jpg`} className="contact-image" /> }
                          <div>
                            <div className="contact-person">{ partner.contact && partner.contact.firstname || "-" } { partner.contact && partner.contact.lastname }</div>
                            {partner.contact && partner.contact.position ? (<div style={{fontWeight: 100, letterSpacing: '1px'}}>{ partner.contact && partner.contact.position }</div>) : ''}
                          </div>
                        </div>
                        { partner.contact && <p style={{marginBottom: '32px', lineHeight: 1.6}}>
                          <a href={'tel:' + partner.contact.phone}>Tel: { partner.contact.phone }</a><br />
                          <a href={'mailto:' + partner.contact.email}>E-Mail: { partner.contact.email }</a>
                        </p> }
                      </div>
                      { partner.contact && <LogeButtonSlim
                        style={{ borderRadius: 0, width: 200, marginBottom: '32px' }}
                        hoverFontColor={"white"}
                        onClick={() => { window.location = "mailto:" + partner.contact.email}}>
                        kontaktieren</LogeButtonSlim> }
                      <span className="group-title">Keywords</span>
                      <div className="tag-container">
                        { partner.tags ? partner.tags.map((tag, i) => <a className="tag" key={i} href={"/partners/q/" + tag} target="_blank">{tag}</a>) : "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </MediaQuery>

              <MediaQuery query="(max-device-width: 900px)">
                <div className="partner-info-container mobile">
                  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
                    <div style={{position: 'relative', flexShrink: 0}} className="partner-logo">
                      { partner.logo && <img src={`${config.get('CLOUDINARY_URL')}q_auto/w_500/${ partner.logo }.jpg`} /> }
                      { isOwnCompany && <EditInformationButton onClick={() => this.updatePartnerLogoModal.openModal() }><img src={editImageIcon} /></EditInformationButton> }
                    </div>
                    <div style={{marginTop: '16px'}}>
                      <span className="group-title" style={{textAlign: 'center'}}>Firma</span>
                      <h1 className="company-name">{ partner.name }</h1>
                      { isOwnCompany && <div style={{ paddingBottom: 30 }}><EditInformationButton inline highlighted={ partnerInformationMissing } onClick={() => this.updateInformationModal.openModal() } ><img src={editIcon} /></EditInformationButton></div> }
                    </div>
                  </div>
                  <div style={{display: 'flex', marginBottom: '32px', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
                    { partner.contact && partner.contact.profileImage && <img src={`${config.get('CLOUDINARY_URL')}q_auto/w_500/${partner.contact.profileImage }.jpg`} className="contact-image" /> }
                    <div>
                      <span className="group-title" style={{display: 'block'}}>Kontaktperson</span>
                      <div className="contact-person">{ partner.contact && partner.contact.firstname || "-" } { partner.contact && partner.contact.lastname }</div>
                      {partner.contact && partner.contact.position ? (<div style={{fontWeight: 100, letterSpacing: '1px'}}>{ partner.contact && partner.contact.position}</div>) : ''}
                      { partner.contact && <p style={{marginBottom: '32px', lineHeight: 1.6}}>
                        <a href={'tel:' + partner.contact.phone}>Tel: { partner.contact.phone }</a><br />
                        <a href={'mailto:' + partner.contact.email}>E-Mail: { partner.contact.email }</a>
                      </p> }
                      { isOwnCompany && <div style={{ paddingBottom: 30 }}><EditInformationButton inline highlighted={ partnerContactInformationMissing } onClick={() => this.updateContactModal.openModal() } ><img src={editIcon} /></EditInformationButton></div> }
                      { partner.contact && <LogeButtonSlim
                        style={{ borderRadius: 0, width: 'auto', margin: '0 0 32px 0' }}
                        hoverFontColor={"white"}
                        onClick={() => { window.location = "mailto:" + partner.contact.email }}>
                        kontaktieren</LogeButtonSlim> }
                    </div>
                  </div>
                  <div className="info-group">
                    <span className="group-title">Beschreibung</span>
                    <p>
                      { partner.description || "-" }
                    </p>
                  </div>
                  <div className="info-group">
                    <span className="group-title">The-Loge Angebote</span>
                    { partner.deals || "-" }
                  </div>
                  <LogeButtonSlim
                        style={{ borderRadius: 0, width: 200, marginBottom: '32px' }}
                        hoverFontColor={"white"}
                        onClick={() => { window.open('https://' + partner.website, '_blank') }}>
                        Zur Website &gt;</LogeButtonSlim>
                  <div className="line"></div>


                  <div className="info-section-mobile">
                    <div className="info-group" style={{width: '50%', paddingRight: '8px'}}>
                      <span className="group-title">Standort</span>
                      <p>
                        { partner.street }<br />
                        { partner.postcode } { partner.location }
                        {/*<br /> Österreich*/}
                      </p>
                    </div>
                    { partner.contact && <div className="info-group" style={{width: '50%', paddingRight: '8px'}}>
                      <span className="group-title">Information</span>
                      <p>
                        { partner.contact.position && <div>{partner.contact.position}:</div>}
                        { partner.contact.firstname } { partner.contact.lastname }
                      </p>

                      <p>
                        UID-Nummer: <br />
                        { partner.uidNumber }
                      </p>
                    </div> }
                    <div className="info-group" style={{width: '100%'}}>
                      <span className="group-title">Kontakt</span>
                      <p>
                        <a href={'tel:' + partner.phone}>Tel.: { partner.phone }</a><br />
                        <a href={'mailto:' + partner.email}>E-Mail: { partner.email }</a>
                      </p>
                    </div>
                  </div>

                  <div className="line"></div>

                  <span className="group-title">Keywords</span>
                  <div className="tag-container">
                    { partner.tags ? partner.tags.map((tag, i) => <a className="tag" key={i} href={"/partners/q/" + tag} target="_blank">{tag}</a>) : "-"}
                  </div>

                </div>
              </MediaQuery>

              {/* MODALS */}

              <UpdatePartnerContactModal partner={ partner } onRef={instance => { this.updateContactModal = instance }} />
              <UpdatePartnerInformationModal partner={ partner } onRef={instance => { this.updateInformationModal = instance }} />
              <UpdatePartnerHeaderImageModal partner={ partner } onRef={instance => { this.updatePartnerHeaderImageModal = instance }} />
              <UpdatePartnerLogoModal partner={ partner } onRef={instance => { this.updatePartnerLogoModal = instance }} />

            </InfoBox>
          </main> }
        </div>
      </Grid>
    )
  }
}

const HeroContainer = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(131.45deg, rgba(255, 255, 255, 0.5) -17.18%, rgba(255, 255, 255, 0) 57.6%), #DAB777;
  height: auto;
  min-height: 210px;
  position: relative;

  @media (max-width: 768px){
    height: auto;
    min-height: 155px;
    align-items: flex-start;
    padding-top: 24px;
  }
`

const EditInformationButton = styled.div`
  position: ${ props => props.inline ? 'initial' : 'absolute' };
  right: 0;
  top: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 10px rgba(0,0,0,0.1);
  transition: all .25s ease-in-out;
  cursor: pointer;
  ${ props => props.highlighted && `
    &::after {
      content: "";
      background: red;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      position: absolute;
      right: 0;
      top: 0;
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    	transform: scale(1);
    	animation: pulse 1.5s ease-in-out infinite;
    }
  `}
  &:hover {
    transform: scale(1.1)
  }
  img {
    width: 50% !important;
    height: 50% !important;
    object-fit: contain;
    border-radius: 0 !important;
  }
`

export default withRouter(PartnerDetail);



// WEBPACK FOOTER //
// /src/pages/PartnerDetail.js